<template>
  <div>
    <Header />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="py-10">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10">
        <div>
          <form
            ref="addCourseRef"
            class="rounded-3xl pt-10 px-6 md:px-10 pb-2 heightfix overflow-y-auto"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
            @submit.prevent="createCourse"
          >
            <div class="flex items-center justify-between flex-wrap">
              <h1
                class="py-2 text-xl text-center font-bold text-blues w-full md:w-auto"
              >
                Add New Course
              </h1>

              <router-link
                :to="{ name: 'InstructorHome' }"
                class="bg-blues text-white rounded-lg text-sm font-semibold px-3 py-1"
                >Back</router-link
              >
            </div>

            <div class="py-10 flex flex-col gap-6">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <!-- <div class="flex flex-col gap-3">
                  <label for="title" class="text-sm">Title <span class="text-red-400">*</span></label>
                  <input id="title" type="text" required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none" />
                </div> -->
                <!-- <div class="flex flex-col gap-3">
                  <label for="batch_year" class="text-sm"
                    >Batch Year <span class="text-red-400">*</span></label
                  >
                  <select
                    id="batch_year"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Batch</option>
                    <option
                      v-for="batch_year in batch_years"
                      :key="batch_year.year"
                      :value="batch_year.year"
                    >
                      {{ batch_year.year }}
                    </option>
                  </select>
                </div> -->
                <div class="flex flex-col gap-3">
                  <label for="program_name" class="text-sm flex gap-2"
                    >Program Name <span class="text-red-400">*</span> 
                    <font-awesome-icon
                      @click="isPrograms = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                    </label
                  >
                  <select
                    id="program_name"
                    required
                    @change="getProgramsFilter()"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                  <option value="" selected disabled>Select Programs</option>
                    <option
                      v-for="program in programs"
                      :key="program.id"
                      :value="program.name"
                    >
                      {{ program.name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="department" class="text-sm flex gap-2"
                    >Departments <span class="text-red-400">*</span>

                    <font-awesome-icon
                      @click="isDepartment = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="department"
                    @change="getInstructorListByFilter()"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                  <option value="" selected disabled>Select Department</option>
                    <option
                      v-for="department in departments"
                      :key="department.id"
                      :value="department.name"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="semester" class="text-sm"
                    >Semester<span class="text-red-400">*</span></label
                  >
                  <select
                    id="semester"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <!-- <option v-for="program in programs" :key="program.id" :value="program.name">
                      {{ category.name }}
                    </option> -->
                    <option value="" selected disabled>Select Semester</option>
                    <option value="I">I</option>
                    <option value="II">II</option>
                    <option value="III">III</option>
                    <option value="IV">IV</option>
                    <option value="V">V</option>
                    <option value="VI">VI</option>
                    <!-- ('I', 'I'),
                    ('II', 'II'),
                    ('III', 'III'),
                    ('IV', 'IV'),
                    ('V', 'V'),
                    ('VI', 'VI'), -->
                  </select>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5"> 

                <div class="flex flex-col gap-3">
                  <label for="section" class="text-sm"
                    >Section <span class="text-red-400">*</span></label
                  >
                  <input
                    id="section"
                    type="text"
                    placeholder="A, B, C.."
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3">
                  <label for="faculty" class="text-sm"
                    >Select Faculty <span class="text-red-400">*</span></label
                  >
                  <!-- {{instructor_lists}} -->
                  <select
                    id="instructor_id"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Faculty</option>
                    <option
                      v-for="instructor_list in instructor_lists"
                      :key="instructor_list.id"
                      :value="instructor_list.id"
                    >
                      {{ instructor_list.user.email }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="title" class="text-sm"
                    >Title <span class="text-red-400">*</span></label
                  >
                  <input
                    id="title"
                    type="text"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="category" class="text-sm flex gap-2"
                    >Category <span class="text-red-400">*</span>
                    <font-awesome-icon
                      @click="is_CategoryPopup = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="category"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                  <option value="" selected disabled>Select Category</option>
                    <option
                      v-for="category in categories"
                      :key="category.id"
                      :value="category.id"
                    >
                      {{ category.title }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="flex flex-col gap-3">
                <label for="short-desc" class="text-sm"
                  >Course objective is to <span class="text-red-400">*</span></label
                >
                <textarea
                  id="short-desc"
                  required
                  maxlength="1000"
                  class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                ></textarea>
              </div>

              <div class="flex flex-col gap-3">
                <label for="description" class="text-sm"
                  >Description <span class="text-red-400">*</span></label
                >
                <QuillEditor
                  style="height: 300px"
                  theme="snow"
                  class="border rounded-2xl"
                  toolbar="full"
                  placeholder="Write your course content"
                  
                  contentType="html"
                />
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="outcome" class="text-sm"
                    >Outcome <span class="text-red-400">*</span></label
                  >
                  <textarea
                    id="outcome"
                    required
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="requirement" class="text-sm">Requirement</label>
                  <textarea
                    id="requirement"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="language" class="text-sm">Language</label>
                  <input
                    id="language"
                    type="text"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="level" class="text-sm">Level</label>
                  <select
                    id="level"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option
                      v-for="level in ['beginner', 'intermediate', 'advanced']"
                      :key="level"
                      :value="level"
                    >
                      {{ level }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="thumbnail" class="text-sm"
                    >Thumbnail <span class="text-red-400">*</span></label
                  >
                  <input
                    id="thumbnail"
                    type="file"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="video_url" class="text-sm">Video URL <span class="text-red-400">*</span></label>
                  <input
                    id="video_url"
                    type="text"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3">
                  <label for="pdf_urls" class="text-sm"
                    >PDF URL</label
                  >
                  <input
                    id="pdf_urls"
                    type="text"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

              </div>

              <div class="flex items-center gap-2">
                <input type="checkbox" id="Published" />
                <label for="Published" class="text-sm">Published</label>
              </div>

              <!-- <div class="flex justify-between">
                <router-link :to="{ name: 'InstructorHome' }"
                  class=" bg-blues text-white rounded-lg text-lg font-semibold px-6 py-1.5">Back</router-link>
                <button type="submit" class="text-white bg-blues rounded-lg text-lg px-8 py-1.5">
                  Save
                </button>
              </div> -->
              <div class="flex gap-3 flex-wrap">
                <button
                  type="submit"
                  class="text-greens border border-greens rounded-lg text-lg font-semibold px-6 py-1.5"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      v-if="is_CategoryPopup"
      @click.self="is_CategoryPopup = false"
      class="fixed top-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="is_CategoryPopup = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Category</h4>
        <form class="w-11/12 mx-auto pb-10" @submit.prevent="categoryAdd">
          <label for="title">
            Title
            <span class="text-red-400">*</span>
          </label>
          <input
            id="title"
            type="text"
            required
            class="border border-gray-300 rounded-md text-sm w-full p-2"
          />
          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Category
          </button>
        </form>
      </div>
    </div>

    <div
      v-if="isDepartment"
      @click.self="isDepartment = false"
      class="fixed top-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isDepartment = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Department
        </h4>
        <form class="w-11/12 mx-auto pb-10 flex flex-col gap-4" ref="addDepartment" @submit.prevent="AddDepartment">

          <div class="flex flex-col gap-1"> 
              <label for="name">
                Program
                <span class="text-red-400">*</span>
              </label>
              <select
                id="program_name"
                required
                class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
              >
                <option
                  v-for="program in programs"
                  :key="program.id"
                  :value="program.id"
                >
                  {{ program.name }}
                </option>
              </select>
            </div>
            

            <div class="flex flex-col gap-1"> 
              <label for="name">
                Name
                <span class="text-red-400">*</span>
              </label>
              <input
                id="name"
                type="text"
                required
                class="border border-gray-300 rounded-md text-sm w-full p-2"
              />
            </div>
          

          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Department
          </button>
        </form>
      </div>
    </div>

    <div
      v-if="isPrograms"
      @click.self="isPrograms = false"
      class="fixed top-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isPrograms = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Programs
        </h4>
        <form class="w-11/12 mx-auto pb-10 flex flex-col gap-2" ref="addProgramsRef" @submit.prevent="AddPrograms">  

            <div class="flex flex-col gap-1"> 
              <label for="name">
                Name
                <span class="text-red-400">*</span>
              </label>
              <input
                id="name"
                type="text"
                required
                class="border border-gray-300 rounded-md text-sm w-full p-2"
              />
            </div>
          

          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Program
          </button>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    Header,
    QuillEditor,
    FlashMessage,
  },

  data() {
    return {
      categories: null,
      info: null,
      msgverify: "",
      messages: {
        text: "",
        type: "null",
      },
      is_CategoryPopup: false,
      description: "",
      batch_years: [],
      programs: [],
      departments: [],
      isDepartment: false,
      isPrograms: false,
      instructor_lists:[],
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {
    
    
    // this.getDepartments();
    this.getPrograms();

    

    axios
      .get(
        `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`
      )
      .then((res) => {
        this.batch_years = res.data.data;
      });

    axios
      .get(`${process.env.VUE_APP_API}/category/?format=json`)
      .then((res) => {
        this.categories = res.data.data;
      });
  },

  methods: {

    getInstructorListByFilter(){
      
      let department_name = document.getElementById("department").value;

      axios
      .get(
        `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}&department__name=${department_name}`
      )
      .then((res) => {
        console.log(res);
        this.instructor_lists = res.data.products;
      });
    },

    getProgramsFilter(){
      let program_name = document.getElementById("program_name").value;

      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__name=${program_name}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });

    },

    AddPrograms(el){
      
      let bodyVal = {
        name: el.target.elements.name.value
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/program_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Program Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isPrograms = false;
              this.getPrograms();
              this.$refs.addProgramsRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    getPrograms(){
      axios
        .get(`${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`)
        .then((res) => {
          this.programs = res.data.data;
        });
    },

    getDepartments() {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },

    categoryget() {
      axios
        .get(`${process.env.VUE_APP_API}/category/?format=json`)
        .then((res) => {
          this.categories = res.data.data;
        });
    },

    AddDepartment(el) {
      let bodyVal = {
        name: el.target.elements.name.value,
        program: el.target.elements.program_name.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/department_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Department Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isDepartment = false;
              this.getDepartments();
              this.$refs.addDepartment.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    categoryAdd(el) {
      let bodyVal = {
        title: el.target.elements.title.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/categorynew/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          console.log(response.data.message);
          if (response.data.message == "your Category added successfully") {
            this.messages = {
              text: "Category Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.is_CategoryPopup = false;
              this.categoryget();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    async createCourse(e) {
      let token = this.userInfo.token_key;

      this.description = document.querySelector(".ql-editor").innerHTML;
      console.log(this.description);

      let urls = `${process.env.VUE_APP_API}/coursenew/?Key=${token}`;
      let HeaderVal = new FormData();
      if (e.target.elements.thumbnail.files.length > 0) {
        var thumbnailVal = e.target.elements.thumbnail.files[0];
        HeaderVal.append("thumbnail", thumbnailVal);
      }

      HeaderVal.append("batch_year", "2024-25");
      HeaderVal.append("program_name", e.target.elements.program_name.value);
      HeaderVal.append("department_name", e.target.elements.department.value);
      HeaderVal.append("semester", e.target.elements.semester.value);

      HeaderVal.append("section", e.target.elements.section.value);

      HeaderVal.append("title", e.target.elements.title.value);
      HeaderVal.append("category", parseInt(e.target.elements.category.value));
      HeaderVal.append(
        "short_description",
        e.target.elements["short-desc"].value
      );
      // HeaderVal.append("description", this.description);
      HeaderVal.append("description", this.description);
      HeaderVal.append("outcome", e.target.elements.outcome.value);
      HeaderVal.append("requirements", e.target.elements.requirement.value);
      HeaderVal.append("language", e.target.elements.language.value);
      HeaderVal.append("price", 0);
      HeaderVal.append("course_free", true);
      HeaderVal.append("level", e.target.elements.level.value);
      HeaderVal.append("video_url", e.target.elements.video_url.value);
      HeaderVal.append("is_published", e.target.elements.Published.checked);
      HeaderVal.append("instructor", this.userInfo.Instructor_id);
      HeaderVal.append("organization_id", this.userInfo.organizes_id);
      HeaderVal.append("pdf_urls", e.target.elements.pdf_urls.value);


      await axios
        .post(urls, HeaderVal, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.message == "your Course added successfully") {
            this.messages = {
              text: "Courses Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.addCourseRef.reset();
              this.$router.push({
                name: "InstructorCourses",
              });
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
